import {useContext, useState} from 'react'
import { themeSwitchWrapper,labelStyle,inputStyle,switchButtonStyle,switchToggleStyle } from '../../../utils/styles/navigationStyles';
import { getTheme,switchTheme } from '../../../utils/themeFunctions';
import { darkTheme, lightTheme } from '../../../models/themeModel';
import { ThemeContext } from '../../../App';

export default function ThemeSwitchComponent(){
    const [theme,setTheme] = useContext(ThemeContext);
    const [isChecked,setIsChecked] = useState(getTheme() === darkTheme)
    const buttonText = () => {
        switch(true){
            case getTheme() == darkTheme:
                return '🌙'
            case getTheme() == lightTheme:
                return '☀️'
            default:
                return 'A'
        }
    }
    return (
        <>
        <button style = {{
            width: '30px',
            height: '30px',
            borderRadius: '100%',
            backgroundColor: theme.primary,
            border: `1px solid ${theme.font.regular}30`,
            color: 'red',
            color: 'transparent',  
            textShadow: `0 0 0 ${theme.font.regular}`
        }}
        onMouseOver={() => {}}
        onClick = {(e) => {
            setIsChecked(e.target.checked)
            setTheme(switchTheme())
        }}
        >
        {buttonText()}
        </button>
        </>
    )
}